export default "__VITE_ASSET__51365a82__"